import { FC, SVGProps } from 'react';
import { Button, ButtonSizes, ButtonStyles, Icons, List, ListItem, MenuButton } from '@silverfort/sf-components';
import { FeatureLock, LockedFeatureDisplayConfig } from '../../../common/LockedFeatures';

export interface TemplateCardActionsProps {
    showMenu?: boolean;
    isFavorite: boolean;
    onAddToFavoritesClick: () => void;
    onRemoveFromFavoritesClick: () => void;
    onStartFromTemplateClick: () => void;
    onEditClick?: () => void;
    onDuplicateClick?: () => void;
    onDeleteClick?: () => void;
    startFromTemplateLockedFeatureConfig?: LockedFeatureDisplayConfig;
}

const TemplateCardActions: FC<TemplateCardActionsProps> = ({
    showMenu = false,
    isFavorite,
    onAddToFavoritesClick,
    onRemoveFromFavoritesClick,
    onStartFromTemplateClick,
    onDeleteClick,
    onDuplicateClick,
    onEditClick,
    startFromTemplateLockedFeatureConfig = { enabled: true }
}) => (
    <div className="relative w-full h-full bg-sf-white bg-opacity-75 flex flex-col justify-center items-center gap-4 p-2 backdrop-blur-sm">
        {showMenu && (
            <div className="absolute top-4 end-4">
                <MenuButton
                    openByDefault={false}
                    className="left-[-168px]"
                    buttonStyle={ButtonStyles.Tertiary}
                    buttonSize={ButtonSizes.Medium}
                    content={
                        <List className="min-w-[184px] [&]:p-0">
                            <ListItem title="Edit" onClick={onEditClick} />
                            <ListItem title="Duplicate" onClick={onDuplicateClick} />
                            <ListItem className="text-sf-negative-500" title="Delete" onClick={onDeleteClick} />
                        </List>
                    }
                />
            </div>
        )}
        {isFavorite ? (
            <Button
                buttonStyle={ButtonStyles.Primary}
                text="Remove from Favorites"
                iconLeft={Icons.Unstar as FC<SVGProps<SVGSVGElement>>}
                onClick={onRemoveFromFavoritesClick}
            />
        ) : (
            <Button
                buttonStyle={ButtonStyles.Primary}
                text="Add to Favorites"
                className="min-w-[150.25px] [&]:justify-start"
                iconLeft={Icons.Star as FC<SVGProps<SVGSVGElement>>}
                onClick={onAddToFavoritesClick}
            />
        )}
        <FeatureLock displayOptions={startFromTemplateLockedFeatureConfig}>
            <Button
                text="Start from Template"
                className="min-w-[150.25px] [&]:justify-start"
                onClick={onStartFromTemplateClick}
            />
        </FeatureLock>
    </div>
);

export default TemplateCardActions;
